import { TopbarCampaign as TopbarCampaignModel } from '~/lib/data-contract';
import { useTopbarCampaignState } from './topbar-campaign-state';
import { getUnixTime } from 'date-fns';
import Marquee from 'react-fast-marquee';
import { CMSLink } from '../cms-link/cms-link.component';
import { Typography } from '../typography/typography.component';
import CloseIcon from '$icons/close.svg';
import styles from './topbar-campaign.module.css';
import clsx from 'clsx';

const TopbarCampaign = ({ topbarCampaign }: { topbarCampaign: TopbarCampaignModel }) => {
    const {
        expiryDatetime,
        link,
        animation,
        title,
        text,
        textColor,
        backgroundColor,
    } = topbarCampaign;
    const { setHideTopBarCampaign } = useTopbarCampaignState();

    if (expiryDatetime) {
        const expiryDatetimeTimestamp = getUnixTime(new Date(expiryDatetime));
        const currentDatetimeTimestamp = getUnixTime(new Date());
        if (expiryDatetimeTimestamp < currentDatetimeTimestamp) {
            return null;
        }
    }

    if (!title && !text) {
        return null;
    }

    return (
        <div className={styles.root} style={{ backgroundColor }}>
            {animation ? (
                <Marquee autoFill speed={30} pauseOnHover>
                    <CMSLink
                        href={link?.url}
                        className={clsx(styles.content, { [styles.marquee]: animation })}
                    >
                        {title && (
                            <Typography
                                as="p"
                                variant="bodySm"
                                children={title}
                                style={{ color: textColor }}
                                className={clsx(styles.title, { [styles.marquee]: animation })}
                            />
                        )}
                        {text && (
                            <Typography
                                as="p"
                                variant="bodySm"
                                children={text}
                                style={{ color: textColor }}
                                className={clsx(styles.text, { [styles.marquee]: animation })}
                            />
                        )}
                    </CMSLink>
                </Marquee>
            ) : (
                <>
                    <CMSLink href={link?.url} className={styles.content}>
                        {title && (
                            <Typography
                                as="p"
                                variant="bodySm"
                                children={title}
                                style={{ color: textColor }}
                                className={styles.title}
                            />
                        )}
                        {text && (
                            <Typography
                                as="p"
                                variant="bodySm"
                                children={text}
                                style={{ color: textColor }}
                                className={styles.text}
                            />
                        )}
                    </CMSLink>
                    <button
                        className={clsx(styles.button, 'cleanButton')}
                        onClick={() => setHideTopBarCampaign(true)}
                        style={{ color: textColor }}
                    >
                        <CloseIcon />
                    </button>
                </>
            )}
        </div>
    );
};

export default TopbarCampaign;
